export enum ReadyState {
  CONNECTING,
  OPEN,
  CLOSING,
  CLOSED,
}

export enum ContentType {
  ArrayBuffer,
  String,
  Blob,
}
